import React, { useState, useEffect, useCallback } from 'react'
import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import CarouselArrow from '@/components/atoms/CarouselArrow/CarouselArrow'

const HorizontalScrollStyle = styled.div`
  margin: 0 auto;
  position: relative;
`

const Grid = styled.div`
  height: 100%;
  border: ${(props) => props.greyBorder};
  scroll-snap-type: y mandatory;
  scroll-snap-align: end;
  scroll-behavior: smooth;
  position: relative;
  display: flex;
  gap: ${(props) =>
    props.removeGap ? '0px' : props.isResourceMenu ? '8px' : '24px'};
  width: 100%;
  justify-content: space-between;
  flex-shrink: 1;
  scrollbar-width: none;
  padding: ${(props) => (props.scrollOverPadding ? '0 24px' : '0')};
  margin: ${(props) => (props.scrollOverPadding ? '0 -24px' : '0')};
  max-width: ${(props) =>
    props.scrollOverPadding ? 'calc(100% + 48px)' : '100%'};
  &::-webkit-scrollbar {
    display: none;
  }
  &::scrollbar {
    display: none;
  }

  ${(props) =>
    props.hideOnDesktop
      ? `
  @media (min-width: 1024px) {
    & > div:nth-child(3) {
      display: none;
    }
    & > div:nth-child(4) {
      display: none;
    }
    & > div:nth-child(5) {
      display: none;
    }
  }
`
      : ''}
  @media (max-width: 1280px) {
    justify-content: space-evenly;
  }

  @media (max-width: 1024px) {
    justify-content: start;
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  @media (max-width: 768px) {
    max-width: none;
    margin: 0 -16px;
    padding: 0 16px;
    width: ${(props) => (props.pickThree ? '100%' : '100vw')};
  }
  ${(prop) =>
    prop.desktopCentered &&
    css`
      justify-content: center !important;
      ${media.lessThan('medium')`
  justify-content: unset !important`}
    `}
  @media (max-width: 1024px) {
    justify-content: start;
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    flex-wrap: nowrap;
  }

  & > .segment-card-tracker > div,
  & > div:not(.segment-card-tracker),
  & > a {
    scroll-snap-align: start;
    flex-shrink: 0;

    ${(props) => (props.isResourceMenu ? `` : 'width: 288px;')}
    contain-intrinsic-width: auto 288px;

    ${media.greaterThan('large')`
      ${(props) => (props.isResourceMenu ? `` : 'width: 320px;')}
      contain-intrinsic-width: auto 320px;      
    `}
  }
  ${(props) =>
    props.alwaysScroll || props.isResourceMenu
      ? `
      scroll-snap-align: start;
    justify-content: start;
    overflow-x: scroll;
    flex-wrap: nowrap;
    width: 100vw;
    @media (max-width: 1280px) {
      justify-content: start;
    }

  @media (min-width: 1280px) {
  & > .segment-card-tracker > div,
  & > div:not(.segment-card-tracker),
  & > div:not(.carousel-skeleton),
  & > a {
    height: ${(props) => (props.height ? `${props.height}px` : '100%')};
    /* max-width: 470px; */
    margin: ${(props) => props.borderMargin || '10px 10px 0px 0px'};
    width: ${(props) => 100 / props.count + '%'};
    flex-shrink: 0;
    margin-bottom: 0;
  }
  }

`
      : `
    flex-wrap: wrap;

`}
`
const HorizontalScroll = ({
  id = '',
  children,
  maxWidth,
  notBlog,
  greyBorder,
  borderMargin,
  pickThree,
  noOverflow,
  desktopCentered,
  gridClassName,
  withGradient = true,
  scrollOverPadding = false,
  removeArrowBorderOffset,
  ...rest
}) => {
  const containerId = `scroll-badge-${id}`

  const [showRightArrow, setShowRightArrow] = useState(false)
  const scrollDiv = (e) => {
    const container = document.getElementById(containerId)
    if (e == -1) {
      container.scroll(container.scrollLeft - 410, 0)
    } else {
      container.scroll(container.scrollLeft + 410, 0)
    }
  }

  useEffect(() => {
    const container = document.getElementById(containerId)
    if (container) {
      const hasOverflow = container.scrollWidth > container.clientWidth
      setShowRightArrow(hasOverflow)
    }
  }, [children, containerId])

  const [showLeftArrow, setShowLeftArrow] = useState(false)

  const handleOnScroll = useCallback(({ currentTarget }) => {
    const hasUserScrollToTheLeft = currentTarget.scrollLeft > 0
    setShowLeftArrow(hasUserScrollToTheLeft)
    const leftMostScrollValue =
      currentTarget.clientWidth + currentTarget.scrollLeft
    const hasUserScrollToTheLeftMost =
      currentTarget.scrollWidth === leftMostScrollValue
    setShowRightArrow(!hasUserScrollToTheLeftMost)
  })

  return (
    <HorizontalScrollStyle>
      <div
        className={`absolute -right-px top-0 z-[2] hidden h-full w-[78px] bg-gradient-to-l ${
          showRightArrow && withGradient ? 'md:block' : ''
        }`}
        style={{
          background:
            'linear-gradient(270deg, #FFF 13.21%, rgba(255, 255, 255, 0.00) 80.13%)'
        }}
      />
      <div
        className={`absolute -left-px top-0 z-[2] hidden h-full w-[78px] bg-gradient-to-r ${
          showLeftArrow && withGradient ? 'md:block' : ''
        }`}
        style={{
          background:
            'linear-gradient(90deg, #FFF 13.21%, rgba(255, 255, 255, 0.00) 80.13%)'
        }}
      />
      <div
        className={`absolute left-0 top-0 hidden h-full w-20 shrink-0 justify-start ${
          withGradient
            ? 'bg-gradient-to-l from-white via-white to-transparent'
            : ''
        } md:items-center ${showLeftArrow ? 'md:flex' : ''}`}
      >
        <CarouselArrow
          size="lg"
          direction="left"
          onClick={(e) => {
            scrollDiv(-1)
          }}
          removeBorderOffset={removeArrowBorderOffset}
        />
      </div>
      <div
        className={`absolute right-0 top-0 hidden h-full w-20 shrink-0 items-end justify-end ${
          withGradient
            ? 'bg-gradient-to-l from-white via-white to-transparent'
            : ''
        } md:items-center ${showRightArrow ? 'md:flex' : ''}`}
      >
        <CarouselArrow
          size="lg"
          direction="right"
          onClick={(e) => {
            scrollDiv(1)
          }}
          removeBorderOffset={removeArrowBorderOffset}
        />
      </div>
      <div className={gridClassName}>
        <Grid
          onScroll={handleOnScroll}
          id={containerId}
          alwaysScroll={true}
          maxWidth={maxWidth}
          count={4}
          desktopCentered={desktopCentered}
          greyBorder={greyBorder}
          borderMargin={borderMargin}
          pickThree={pickThree}
          noOverflow={noOverflow}
          scrollOverPadding={scrollOverPadding}
          {...rest}
        >
          {children}
        </Grid>
      </div>
    </HorizontalScrollStyle>
  )
}
export default HorizontalScroll
